import ReactDOM from 'react-dom'

import { initMswWorker } from './__mocks__/browser'
import App from './app'

initMswWorker().then(() => {
  ReactDOM.render(<App />, document.getElementById('root'))
})
